module.exports = __webpack_public_path__ + "static/media/PaymentSplitEvenly.59cac97b.png";